import { useMemo, useState } from "react";
import cloneDeep from "lodash/cloneDeep";
import newIdAttributesGenerator from "../../../../helpers/newIdAttributesGenerator";

const useEditAttributePopup = ({ popupData, closePopup }) => {
  const { attribute, onFinish } = popupData?.item;
  const formattedAttribute =
    attribute?.unit?.options?.length > 0
      ? { ...attribute, fieldType: "number-entry-with-unit" }
      : attribute;
  const [editedAttribute, setEditedAttribute] = useState(
    cloneDeep(formattedAttribute)
  );

  const formatForDDL = useMemo(() => {
    const options = [];
    const units = [];
    if (editedAttribute?.options?.length) {
      editedAttribute?.options?.forEach((item) => {
        if (item?.name || item?.label) {
          const value = item?.value;
          const label = item?.name;
          options.push({ label, value, id: value, name: label });
        }
      });
    }
    if (editedAttribute?.unit?.options?.length) {
      editedAttribute?.unit?.options?.forEach((item) => {
        if (item?.name || item?.label) {
          const value = item?.value;
          const label = item?.name || item?.label;
          units.push({ label, value, id: value, name: label });
        }
      });
    }
    return { options, units };
  }, [editedAttribute?.options, editedAttribute?.unit?.options]);

  // Update Name(attribute.detail) of DDL(List) or Number with units fieldTypes
  const handleChangeDetail = (val) => {
    setEditedAttribute((prev) => ({
      ...prev,
      detail: val,
    }));
  };

  // Update options for DDL (List) fieldType
  const handleChangeOptions = ({ val }) => {
    setEditedAttribute((prev) => ({
      ...prev,
      options: val?.map((opt) => ({
        name: opt?.label,
        label: opt?.label,
        value: newIdAttributesGenerator(opt),
      })),
    }));
  };

  // Update options for Number-With-Units fieldType
  const handleChangeUnitOptions = ({ val }) => {
    setEditedAttribute((prev) => ({
      ...prev,
      unit: {
        ...prev.unit,
        options: val?.map((opt) => ({
          label: opt?.label,
          name: opt?.label,
          value: newIdAttributesGenerator(opt),
        })),
      },
    }));
  };

  const handleChangeFieldType = ({ val }) => {
    setEditedAttribute((prev) => ({
      ...prev,
      fieldType: val.value,
      options: [],
      unit: {
        options: [],
      },
    }));
  };

  // TODO: (Parker) No figma design for this, unsure of all requirements; This May need to be updated to be used as a onRowClick
  // in the table, allowing editing in pop-up vs in-table

  // Call onFinish from useAttributesManagementList that dispatches to the Attribute Reducer to update the edited Attribute
  const handleFinish = () => {
    onFinish({ attribute: { ...editedAttribute, wasUpdated: true } });
    closePopup();
  };

  // DDL and Unit options have a second input that needs gap-6
  const isDDL = useMemo(() => {
    return editedAttribute?.fieldType === "ddl";
  }, [editedAttribute?.fieldType]);

  const isUnit = useMemo(() => {
    return editedAttribute?.fieldType === "number-entry-with-unit";
  }, [editedAttribute?.fieldType]);

  return {
    editedAttribute,
    handleChangeDetail,
    handleChangeOptions,
    handleChangeUnitOptions,
    handleChangeFieldType,
    handleFinish,
    isDDL,
    isUnit,
    formatForDDL,
  };
};

export default useEditAttributePopup;
